import { AccountConstants } from '../constants';
import { RequestAction } from '@redux-requests/core';
import { gql } from '@redux-requests/graphql';

export interface IDeveloperProfile {
  firstName: string;
  lastName: string;
  companyName: string;
  website?: string;
  phone: string;
}

export const saveDeveloperProfile = ({
  firstName,
  lastName,
  companyName,
  website = '',
  phone,
}: IDeveloperProfile): RequestAction => ({
  type: AccountConstants.SAVE_DEVELOPER_PROFILE,
  request: {
    query: gql`
      mutation(
        $firstName: String
        $lastName: String
        $companyName: String
        $website: String
        $phone: String
      ) {
        saveDeveloperProfile(
          developer: {
            firstName: $firstName
            lastName: $lastName
            companyName: $companyName
            phone: { number: $phone, country: "GB" }
            website: $website
          }
        ) {
          firstName
          lastName
          companyName
          website
          phone {
            phone
          }
        }
      }
    `,
    variables: { firstName, lastName, companyName, website, phone },
  },
  meta: {
    mutations: {
      [AccountConstants.ACCOUNT]: (data, { saveDeveloperProfile }) => ({
        ...data,
        ...saveDeveloperProfile,
      }),
    },
  },
});
